export class TeamModel {

    public isInit: boolean = true;

    public teams: TeamItemModel[] = [];
    public users: UserItemModel[] = [];

    public deletingTeamId: number = null;
    public deletingUser: UserItemModel = null;

    public createTeamDialogModel: CreateTeamDialogModel = null;
    public inviteUserDialogModel: InviteUserDialogModel = null;
    public editUserDialogModel: EditUserDialogModel = null;
    public changeVacationCountDialogModel: ChangeVacationCountDialogModel = null;

}

export class TeamItemModel {

    public constructor(
        public id: number,
        public name: string,
        public userCount: number
    ) { }

}

export class UserItemModel {

    public constructor(
        public id: string,
        public name: string,
        public email: string,
        public roleName: string,
        public roleTitle: string,
        public teamId: number,
        public teamName: string,
        public pendingInvitation: boolean
    ) { }

}

export class CreateTeamDialogModel {

    public name: string = "";
    public nameError: string = null;

}

export class InviteUserDialogModel {

    public name: string = "";
    public email: string = "";
    public role: string = "USER";
    public teamId: string = "";
    public yearlyVacations: string = "25";
    public rolledVacations: string = "0";
    public usedUpVacations: string = "0";

    public nameError: string = null;
    public emailError: string = null;
    public roleError: string = null;
    public teamError: string = null;
    public yearlyVacationsError: string = null;
    public rolledVacationsError: string = null;
    public usedUpVacationsError: string = null;

}

export class EditUserDialogModel {

    public constructor(
        public userId: number,
        public name: string,
        public role: string,
        public teamId: string
    ) { }

    public nameError: string = null;
    public roleError: string = null;
    public teamError: string = null;

}

export class ChangeVacationCountDialogModel {

    public constructor(
        public userId: number,
        public yearlyVacationCount: string,
        public rolledVacationCount: string
    ) { }

    public yearlyVacationCountError: string = null;
    public rolledVacationCountError: string = null;

}
